import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Add } from "@faire/web--source/slate/icons/foundation/Add";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import React from "react";
import styled, { css } from "styled-components";
export var RoundedPlusButton = function(props) {
    var _React_useState = _sliced_to_array(React.useState(false), 2), loading = _React_useState[0], setLoading = _React_useState[1];
    var onClick = React.useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(e) {
            var _props_onClick;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            ,
                            2,
                            3
                        ]);
                        setLoading(true);
                        return [
                            4,
                            (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, e)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e) {
            return _ref.apply(this, arguments);
        };
    }(), [
        props,
        setLoading
    ]);
    return /*#__PURE__*/ _jsx(Container, _object_spread_props(_object_spread({
        forwardedAs: "button"
    }, props), {
        role: "button",
        onClick: onClick,
        disabled: loading || props.disabled,
        children: loading ? /*#__PURE__*/ _jsx(LoadingSpinner, {
            size: "small",
            color: Core.text.inverse
        }) : /*#__PURE__*/ _jsx(Add, {})
    }));
};
var Container = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-90c30808-0"
})([
    "",
    ""
], function(param) {
    var theme = param.theme;
    return css([
        "background-color:",
        ";color:",
        ";border:solid 1px ",
        ";width:32px;height:32px;border-radius:32px;flex:0 0 auto;&:hover{background-color:",
        ";color:",
        ";border-color:",
        ";}&:disabled{background-color:",
        ";border-color:",
        ";color:",
        ";}"
    ], theme.surface.muted, theme.text.default, theme.border.muted, theme.surface.default, theme.text.inverse, theme.border.default, theme.surface.disabled, theme.border.disabled, theme.text.disabled);
});
